import { Component, OnInit, OnDestroy } from '@angular/core';
import { IOption } from 'src/app/ui/interfaces/option';
import { BasePageComponent } from '../base-page';
import { HttpService } from 'src/app/services/http/http.service';
import { FormBuilder } from '@angular/forms';
import { IAppState } from 'src/app/interfaces/app-state';
import { Store } from '@ngrx/store';
import Swal from 'sweetalert2';
import { HttpErrorResponse } from '@angular/common/http';
import swal from 'sweetalert2'
import { Spinkit } from 'ng-http-loader'; //
import { Router } from '@angular/router'
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-aboutresto',
  templateUrl: './aboutresto.component.html',
  styleUrls: ['./aboutresto.component.scss']
})
export class AboutrestoComponent extends BasePageComponent implements OnInit, OnDestroy {
  public spinkit = Spinkit;
  restoID;
  errorMessage;
  restoDeatils: any;
  imageFile: FormData;
  messageFilesize: string;
  currentAvatar: string | ArrayBuffer;
  disablesFile
  restaurant_id
  restaurant_desc_fb
  restoDetail
  restaurant_desc_insta
  defalutimage ='./assets/img/PngItem_1503945.png'
  resto_text: any;
  restaurant_desc_link: any;
  google_map_url:any
  constructor(
    store: Store<IAppState>,
    httpSv: HttpService,
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    super(store, httpSv);
  }

  ngOnInit(): void {
    this.restoID = localStorage.getItem('restoID');
    this.getReturant();
    this.restaurantDesc();
  }
  logout() {
    this.httpSv.logout().subscribe(
      response => {
        localStorage.clear();
        setTimeout(()=>{
          this.router.navigate(['/public/sign-in'])
        })
      },
      err => {
        console.log(err);
      }
    );
  }

  restaurantDesc(){
    this.httpSv.restaurantDesc().subscribe(
      response => {
        if (response['status'] == true) {
          this.resto_text = response['result'].data[0].restaurant_desc_text
          this.restaurant_desc_link = response['result'].data[0].restaurant_desc_link
          this.restaurant_desc_fb = response['result'].data[0].restaurant_desc_fb
          this.restaurant_desc_insta =response['result'].data[0].restaurant_desc_insta
          this.google_map_url =response['result'].data[0].google_map_url
        }  
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  openUrlOnNewTab(url:string){
    window.open(url, "_blank");
  }
  onclickFb(){
    window.open(environment.sharelinkUrlFb + this.restaurant_desc_link)
  }
  onclickwhatapp(){
    window.open(environment.sharelinkUrlwhatapp +this.restaurant_desc_link )
  }
  onclickTwitter(){
  window.open(environment.sharelinkUrltwitter +this.restaurant_desc_link )
  }
  Onupdate(rstodetail,rstolink,restaurant_desc_fb,restaurant_desc_insta){
    let data = {
      restaurant_desc_text:rstodetail,
      restaurant_desc_link:rstolink,
      restaurant_desc_fb:restaurant_desc_fb,
      restaurant_desc_insta:restaurant_desc_insta,
      google_map_url:this.google_map_url
    }
    this.httpSv.updaterestaurantDesc(data).subscribe(
      response => {
        if (response['status'] == true) { 
        } 
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message.restaurant_desc_text;
        if (err.status == 422) {
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          })
        }
       else if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )

  }
  getReturant() {
    this.httpSv.getReturant(this.restoID).subscribe(
      response => {
        if (response['status'] == true) {
          this.currentAvatar = response['result'].data.logo
          this.restaurant_id = response['result'].data.restaurant_id
        } 
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err;
        this.restoDeatils
        this.errorMessage = err;
        if (err.status == 401 || err.status == 500) {
          this.logout();
        }
      }
    )
  }
  fileChange(event) {
    let fileList: FileList = event.target.files;
  }
onImageChange(event){
  if (event.target.files && event.target.files[0]) {
    const fsize = event.target.files[0].size; 
    const fileSize = Math.round((fsize / 1024));
    if(fileSize < 2048){
      this.imageFile = new FormData();
      this.imageFile.append('file',event.target.files[0]);
      this.imageFile.append('restaurant_id',this.restoID );
      let file: File = event.target.files[0];
      let reader: FileReader = new FileReader();
      this.messageFilesize=""
      reader.onloadend = () => {
        this.currentAvatar = reader.result;
      };
      reader.readAsDataURL(file);
      this.uploadImage();
  }
  else{
    this.messageFilesize="File too Big, please select a file less than 2mb"
  }
    }
   
}

uploadImage(){
  this.httpSv.upload_restaurant_image(this.imageFile).subscribe(
    response => {
      if (response['status'] == true) {
        location.reload();
      }
    },
    (err: HttpErrorResponse) => {
      this.errorMessage = err;
      if (err.status == 401 || err.status == 500) {
        this.logout();
      }
  })
}
  Onclickbutton() {
    this.router.navigate(['horizontal/main']);
  }

}
